<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-form ref="CoreTimeFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="global-icon" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    Monthly Performance Output Report (MPOR)
                  </div>

                  <div class="dialog-subtitle">
                    Manage and monitor monthly accomplishments, outputs, and
                    performance results.
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-row>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
                <v-autocomplete
                  @change="changeMPOR()"
                  v-model="selectedMonth"
                  dense
                  outlined
                  class="rounded-lg"
                  item-text="name"
                  item-value="id"
                  label="Month"
                  color="#93CB5B"
                  :items="monthsList"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" class="pt-2 px-4" v-if="tab != 3">
                <div class="text-12 font-weight-bold ma-2">
                  Status:
                  <v-chip small class="pa-2" v-if="getMPORData.isSubmitted == 0"
                    >For submission</v-chip
                  >
                  <v-chip
                    small
                    class="pa-2"
                    v-if="
                      getMPORData.isSubmitted == 1 &&
                        getMPORData.head_approval_status == 1
                    "
                    >For approval</v-chip
                  >
                  <v-chip
                    small
                    color="green"
                    class="pa-2 white--text"
                    v-if="
                      getMPORData.isSubmitted == 1 &&
                        getMPORData.head_approval_status == 2
                    "
                    >Approved</v-chip
                  >
                  <v-chip
                    small
                    color="red"
                    class="pa-2 white--text"
                    v-if="
                      getMPORData.isSubmitted == 1 &&
                        getMPORData.head_approval_status == 3
                    "
                    >Pending</v-chip
                  >
                </div>
                <v-card class="dt-container" elevation="0" outlined>
                  <v-data-table
                    :expanded.sync="expanded"
                    :headers="headers"
                    :items="dataItem"
                    :items-per-page="-1"
                    :item-class="setPendingClass"
                    show-expand
                  >
                    <template v-slot:[`item.suc_ind`]="{ item }">
                      <div class="text-justify">
                        <!-- {{ getItemSuccessIndicator(item) }} -->
                        {{ item.success_indicator }}
                      </div>
                    </template>
                    <template v-slot:[`item.efficiency`]="{ item }">
                      {{ item.mpor ? getTotal("E", item) : "" }}
                    </template>
                    <template v-slot:[`item.quality`]="{ item }">
                      {{ item.mpor ? getTotal("Q", item) : "" }}
                    </template>
                    <template v-slot:[`item.timeliness`]="{ item }">
                      {{ item.mpor ? getTotal("T", item) : "" }}
                    </template>
                    <template v-slot:[`item.remarks`]="{ item }">
                      {{ item.mpor ? item.mpor.remarks : "" }}
                    </template>
                    <template v-slot:[`item.approval_status`]="{ item }">
                      <v-chip
                        x-small
                        class="pa-2"
                        v-if="item.mpor.isSubmitted == 0"
                        >For submission</v-chip
                      >
                      <v-chip
                        x-small
                        class="pa-2"
                        v-if="
                          item.mpor.isSubmitted == 1 &&
                            item.mpor.head_approval_status == 1
                        "
                        >For approval</v-chip
                      >
                      <v-chip
                        x-small
                        color="green"
                        class="pa-2 white--text"
                        v-if="
                          item.mpor.isSubmitted == 1 &&
                            item.mpor.head_approval_status == 2
                        "
                        >Approved</v-chip
                      >
                      <v-chip
                        x-small
                        color="red"
                        class="pa-2 white--text"
                        v-if="
                          item.mpor.isSubmitted == 1 &&
                            item.mpor.head_approval_status == 3
                        "
                        >Pending</v-chip
                      >
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <table id="tbl_expanded">
                          <tr>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width: 33%"
                            >
                              Efficiency
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width: 33%"
                            >
                              Quality
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              colspan="5"
                              style="width: 33%"
                            >
                              Timeliness
                            </th>
                          </tr>
                          <tr>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 1
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 2
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 3
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Week 4
                            </td>
                            <td
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              Total
                            </td>
                          </tr>

                          <tbody>
                            <tr>
                              <td
                                :colspan="!item.eff_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.eff_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.e_w1
                                }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w2 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w3 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.e_w4 }}
                              </td>
                              <td
                                v-if="item.eff_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("E", item) }}
                              </td>
                              <td
                                :colspan="!item.qly_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.qly_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.q_w1
                                }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w2 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w3 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.q_w4 }}
                              </td>
                              <td
                                v-if="item.qly_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("Q", item) }}
                              </td>
                              <td
                                :colspan="!item.timeliness_is_rated ? 5 : 1"
                                align="center"
                                class="text-caption"
                              >
                                {{
                                  !item.timeliness_is_rated
                                    ? "Not to be Rated"
                                    : item.mpor.t_w1
                                }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w2 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w3 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ item.mpor.t_w4 }}
                              </td>
                              <td
                                v-if="item.timeliness_is_rated"
                                align="center"
                                class="text-caption"
                              >
                                {{ getTotal("T", item) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        v-if="
                          getMPORData.isSubmitted &&
                            getMPORData.head_approval_status == 3 &&
                            (tab != 3
                              ? hasUnOpennedRemarks(item.mpor.pendingRemarks) >
                                0
                              : false)
                        "
                        x-small
                        class="my-1"
                        @click="showPendingRemarks(item.mpor.pendingRemarks)"
                        outlined
                        color="primary"
                        block
                        >Show Remarks</v-btn
                      >
                      <v-btn
                        v-if="!getIsSubmitted"
                        x-small
                        @click="update(item)"
                        outlined
                        color="warning"
                        >Update Output
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="tab == 3">
                <v-card
                  class="gdrive-card"
                  elevation="0"
                  outlined
                  ref="GDriveLinkRef"
                >
                  <div class="gdrive-header">
                    <div class="gdrive-icon">
                      <v-icon color="#147452" size="30"
                        >mdi-google-drive</v-icon
                      >
                    </div>

                    <div>
                      <div class="section-title">Google Drive Submission</div>
                      <div class="section-subtitle">
                        Paste the shared Google Drive folder or file link where
                        your supporting documents are stored.
                      </div>
                    </div>
                  </div>

                  <v-divider class="my-5"></v-divider>

                  <div v-if="!showUpdateLinkBtn">
                    <v-text-field
                      v-model="gdrive_link"
                      outlined
                      prepend-inner-icon="mdi-link-variant"
                      color="#147452"
                      placeholder="https://drive.google.com/..."
                      :rules="
                        !showUpdateLinkBtn
                          ? [formRules.required, formRules.isValidGDriveLink]
                          : []
                      "
                    ></v-text-field>

                    <div class="text-caption grey--text mt-n2 mb-5">
                      Ensure that the Google Drive link is accessible to
                      authorized evaluators.
                    </div>

                    <div class="text-right">
                      <v-btn
                        v-if="toUpdateLink"
                        outlined
                        class="btn-pending mr-2"
                        @click="undoUpdate()"
                      >
                        Undo
                      </v-btn>

                      <v-btn
                        class="btn-save"
                        @click="saveLink()"
                        :disabled="saveLinkbtn"
                        :loading="saveLinkbtn"
                      >
                        Save Link
                      </v-btn>
                    </div>
                  </div>

                  <div v-else>
                    <div class="saved-box mb-5">
                      <v-icon color="#147452" class="mr-2">
                        mdi-check-circle
                      </v-icon>

                      <span
                        >Your Google Drive link has been saved
                        successfully.</span
                      >
                    </div>

                    <div class="text-right">
                      <v-btn
                        class="mr-2 btn-print"
                        style="width: 150px"
                        @click="showGDrive()"
                      >
                        View Google Drive
                      </v-btn>

                      <v-btn
                        v-if="!getIsSubmitted"
                        class="btn-save"
                        @click="updateLink()"
                      >
                        Update Link
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="getHasData">
              <v-col
                cols="12"
                v-if="
                  getMPORData.isSubmitted == 1 &&
                    getMPORData.head_approval_status == 2
                "
              >
                <v-divider class="mb-4"></v-divider>

                <div class="global-comment-card">
                  <div class="global-comment-header">
                    <div class="global-comment-icon">
                      <v-icon color="#147452">
                        mdi-message-text-outline
                      </v-icon>
                    </div>

                    <div>
                      <div class="global-comment-title">
                        Comments & Recommendations
                      </div>

                      <div class="global-comment-subtitle">
                        Development feedback and recommendations from the
                        evaluator
                      </div>
                    </div>
                  </div>

                  <div class="global-comment-content">
                    {{
                      getMPORData.observation_and_remarks ||
                        "No comments provided."
                    }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-card-text class="pa-1 mt-8 d-flex justify-end">
              <v-btn
                outlined
                @click="viewMPOR()"
                v-if="getIsSubmitted"
                class="btn-print"
              >
                Print
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn
                v-if="!getIsSubmitted"
                class="btn-save"
                @click="submit()"
                :disabled="isloading"
                :loading="isloading"
              >
                Submit
              </v-btn>
            </v-card-text>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="confirmSubmitDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">Submit for Approval?</div>

          <div class="delete-description">
            Are you sure you want to submit this MPOR for the month of
            <b>{{ getSelectedMonthName }} {{ ipcr ? ipcr.year : "" }}</b>
            ?<br />
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            class="btn-save"
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="fileUploadDialog"
      transition="dialog-bottom-transition"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>{{ uploadFileAction }} Attachment</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="fileUploadDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-form @submit.prevent ref="AttachmentFormref">
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="file_selected"
                  :rules="[formRules.required, formRules.isPDF]"
                  accept="application/pdf"
                  outlined
                  color="#6DB249"
                  dense
                  label="Upload file"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn outlined color="red" @click="fileUploadDialog = false"
            >Close</v-btn
          >
          <v-btn
            class="white--text"
            :color="$vuetify.theme.themes.light.submitBtns"
            @click="saveAttachment()"
            :disabled="isAttachmentBtnLoading"
            :loading="isAttachmentBtnLoading"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MPOROutputDialog :data="mporData" />

    <ViewRemarksTimelineDialog
      :data="pendingList"
      :viewFrom="'Owner'"
      v-on:closeRemarksTimeline="initialize()"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import ViewRemarksTimelineDialog from "../Views/ViewRemarksTimelineDialog.vue";
import icon from "@/assets/icon.vue";
export default {
  components: {
    MPOROutputDialog: () => import("../Forms/MPOROutputDialog.vue"),
    ViewRemarksTimelineDialog,
    icon,
  },
  props: {
    data: null,
  },
  data() {
    return {
      action: null,
      isloading: null,
      confirmSubmitDialog: false,
      confirmBtnLoading: false,
      loading: false,
      gdrive_link: null,
      saveLinkbtn: false,
      toUpdateLink: false,
      ipcr_gDriveLink: null,
      remarksData: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      options: {},

      expanded: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Attachment" },
      ],
      mporData: null,
      ipcr: null,
      ipcrID: null,
      curData: [],
      dataItem: [],
      monthsList: [],
      monthSelection1: [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
      ],
      monthSelection2: [
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ],
      monthSelection3: [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ],
      selectedMonth: null,
      headers: [
        {
          text: "Major Function Output",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Status",
        //   value: "approval_status",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
          width: 100,
          valign: "center",
          sortable: false,
        },
      ],
      file_selected: null,
      fileUploadDialog: false,
      isAttachmentBtnLoading: false,
      attachment: null,
      uploadFileAction: null,
      pendingList: [],
    };
  },
  computed: {
    getIsSubmitted() {
      let toReturn = false;
      var submit = [];
      var approval = [];
      if (this.curData.length > 0) {
        if (this.tab != 3) {
          for (let i = 0; i < this.curData.length; i++) {
            let tempData = this.curData[i];
            for (let j = 0; j < tempData.length; j++) {
              submit.push(tempData[j].mpor.isSubmitted);
              approval.push(tempData[j].mpor.head_approval_status);
            }
          }

          if (submit.includes(0)) {
            if (approval.includes(1) || approval.includes(3)) {
              return false;
            } else {
              return true;
            }
          } else {
            if (approval.includes(3)) {
              return false;
            } else {
              return true;
            }
          }
        } else {
          // if (!this.gdrive_link) {
          //   alert("1");
          //   toReturn = false;
          // } else {
          if (this.getMPORData.isSubmitted == 0) {
            toReturn = false;
          } else if (this.getMPORData.isSubmitted == 1) {
            toReturn = true;
            console.log("getMPORData", this.getMPORData);
          } else {
            if (this.getMPORData.head_approval_status != 2) {
              toReturn = false;
            } else {
              toReturn = true;
            }
          }
          // }
        }
      }
      return toReturn;
    },

    getSelectedMonthName() {
      let name = "";
      for (let i = 0; i < this.monthsList.length; i++) {
        if (this.monthsList[i].id == this.selectedMonth) {
          name = this.monthsList[i].name;
        }
      }
      return name;
    },
    showUpdateLinkBtn() {
      let show = false;
      if (this.ipcr_gDriveLink) {
        if (this.toUpdateLink) {
          show = false;
        } else {
          show = true;
        }
      }
      return show;
    },

    getHasData() {
      return this.dataItem.length > 0;
    },

    getMPORData() {
      let isSubmitted = 0;
      let observation_and_remarks = "";
      let head_approval_status;
      if (this.curData.length > 0) {
        isSubmitted = this.curData[0][0].mpor.isSubmitted;
        observation_and_remarks = this.curData[0][0].mpor
          .observation_and_remarks;
        head_approval_status = this.curData[0][0].mpor.head_approval_status;
      }
      return {
        isSubmitted,
        observation_and_remarks,
        head_approval_status,
      };
    },
  },
  watch: {
    data: {
      handler(data) {
        this.tab = 1;
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.selectedMonth = 1;
        this.ipcr = data;
        this.ipcrID = data.id;
        this.toUpdateLink = false;
        console.log("this is data", data);
        this.loadMonthList(data.periodFrom, data.periodTo);
        this.getGDriveLink(data.id);
        // if (data.period == 1) {
        //   this.selectedMonth = this.monthSelection1[0].id;
        //   this.monthsList = this.monthSelection1;
        // } else if (data.period == 2) {
        //   this.selectedMonth = this.monthSelection2[0].id;
        //   this.monthsList = this.monthSelection2;
        // } else if (data.period == 3) {
        //   this.selectedMonth = this.monthSelection3[0].id;
        //   this.monthsList = this.monthSelection3;
        // }
        this.loadRemarks(data.id);
        this.initialize();
        this.getAttachment();
      },
      deep: true,
    },

    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeMPOROutputDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeMPOROutputDialog");
  },
  methods: {
    loadMonthList(from, to) {
      let mnth = [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ];
      this.monthsList = [];
      this.selectedMonth = null;

      for (let i = from - 1; i < to; i++) {
        this.monthsList.push(mnth[i]);
      }
      this.selectedMonth = this.monthsList[0].id;
      console.log(this.monthsList);
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/MPOR", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    initialize() {
      this.loading = true;
      // if (this.tab != 3) {
      this.axiosCall(
        "/ipcr-target/getMyIPCRTargetMPOR/" +
          this.ipcrID +
          "/" +
          this.selectedMonth,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("RESPONSE", res.data);
          this.curData = res.data;
          if (this.tab != 3) {
            this.dataItem = res.data[this.tab - 1];
          }

          this.loading = false;
        }
      });
      // }
      // else {
      //   this.curData = [];
      // }
    },
    getAttachment() {
      this.axiosCall(
        "/ipcr-mpor/getMPORAttachment/" +
          this.ipcrID +
          "/" +
          this.selectedMonth,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("Attachment", res.data);
          this.attachment = res.data;
          // this.curData = res.data;
          // this.dataItem = res.data[this.tab - 1];

          // this.loading = false;
        }
      });
    },

    setPendingClass(item) {
      if (this.getMPORData.head_approval_status == 3) {
        if (this.tab != 3) {
          let list = item.mpor.pendingRemarks;
          let has = false;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isOpenned == 0) {
                has = true;
                break;
              }
            }
            if (has) {
              return "red lighten-4";
            }
          }
          return "";
        }
      }
      return "";
    },

    hasUnOpennedRemarks(list) {
      if (list && list.length > 0) {
        let has = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isOpenned == 0) {
            has = true;
            break;
          }
        }
        if (has) {
          return has;
        } else {
          if (
            this.getMPORData.head_approval_status != 2 &&
            this.getMPORData.isSubmitted
          ) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    showPendingRemarks(item) {
      this.pendingList = [];
      setTimeout(() => {
        this.pendingList = item;
      }, 100);
    },

    changeMPOR() {
      this.initialize();
      this.getAttachment();
      this.getGDriveLink(this.ipcrID);
    },
    showFileUpload() {
      this.file_selected = null;
      this.fileUploadDialog = true;
      this.uploadFileAction = "Add";
    },
    reupload() {
      this.file_selected = null;
      this.fileUploadDialog = true;
      this.uploadFileAction = "Update";
    },
    getItemSuccessIndicator(item) {
      return item.efficiency_type == "percentage"
        ? item.efficiency +
            "%" +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness
        : item.efficiency +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness;
    },
    getTotal(field, item) {
      if (item) {
        let i = item.mpor;

        if (field == "E") {
          let total = 0;
          if (item.eff_is_rated) {
            if (
              i.e_w1 != null &&
              i.e_w2 != null &&
              i.e_w3 != null &&
              i.e_w4 != null
            ) {
              total += i ? (i.e_w1 ? i.e_w1 : 0) : 0;
              total += i ? (i.e_w2 ? i.e_w2 : 0) : 0;
              total += i ? (i.e_w3 ? i.e_w3 : 0) : 0;
              total += i ? (i.e_w4 ? i.e_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        } else if (field == "Q") {
          let total = 0;
          if (item.qly_is_rated) {
            if (
              i.q_w1 != null &&
              i.q_w2 != null &&
              i.q_w3 != null &&
              i.q_w4 != null
            ) {
              total += i ? (i.q_w1 ? i.q_w1 : 0) : 0;
              total += i ? (i.q_w2 ? i.q_w2 : 0) : 0;
              total += i ? (i.q_w3 ? i.q_w3 : 0) : 0;
              total += i ? (i.q_w4 ? i.q_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        } else if (field == "T") {
          let total = 0;
          if (item.timeliness_is_rated) {
            if (
              i.t_w1 != null &&
              i.t_w2 != null &&
              i.t_w3 != null &&
              i.t_w4 != null
            ) {
              total += i ? (i.t_w1 ? i.t_w1 : 0) : 0;
              total += i ? (i.t_w2 ? i.t_w2 : 0) : 0;
              total += i ? (i.t_w3 ? i.t_w3 : 0) : 0;
              total += i ? (i.t_w4 ? i.t_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        }
      }
    },
    undoUpdate() {
      this.gdrive_link = null;
      this.toUpdateLink = false;
    },
    closeD() {
      this.eventHub.$emit("closeMPORDialog", false);
      this.dialog = false;
    },
    AddFuncion() {
      this.ipcrData = { id: null };
      this.action = "Add";
    },
    update(item) {
      this.mporData = item;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    submit() {
      // alert(this.showUpdateLinkBtn);
      // alert(this.selectedMonth);

      if (!this.showUpdateLinkBtn) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message =
          "Please paste the link of your Google Drive as attachments.";
      } else {
        this.confirmSubmitDialog = true;
      }
    },
    getGDriveLink(id) {
      if (id) {
        // alert(id);
        this.axiosCall(
          "/ipcr/getMPORGDriveLink/" + id + "/" + this.selectedMonth,
          "GET",
        ).then((res) => {
          if (res.data !== null) {
            console.log("LINK", res.data);
            this.ipcr_gDriveLink = res.data;
            this.toUpdateLink = false;
          } else {
            this.gdrive_link = null;
            this.ipcr_gDriveLink = null;
            this.toUpdateLink = true;
            console.log("Walay Sulod");
          }
        });
      }
    },

    saveLink() {
      this.saveLinkbtn = true;
      // if (this.$refs.GDriveLinkRef.validate()) {
      if (this.gdrive_link && this.ipcr) {
        this.saveLinkbtn = true;
        let data = {
          id: this.ipcr_gDriveLink ? this.ipcr_gDriveLink.id : null,
          link: this.gdrive_link,
          month: this.selectedMonth,
        };
        this.axiosCall(
          "/ipcr/setMporIPCRGDriveLink/" + this.ipcr.id,
          "PATCH",
          data,
        ).then((res) => {
          if (res.data.status == 200) {
            this.saveLinkbtn = false;
            this.toUpdateLink = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.getGDriveLink(this.ipcr.id);
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      } else {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message =
          "Please paste the link of your Google Drive as attachments.";
      }
      // } else {
      //   this.saveLinkbtn = false;
      // }
    },
    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },
    confirmSubmit() {
      this.confirmBtnLoading = true;
      let data = {
        ipcrID: this.ipcr.id,
        selectedMonth: this.selectedMonth,
      };
      this.axiosCall("/ipcr-mpor/submitMPOR", "POST", data).then((res) => {
        if (res) {
          this.confirmBtnLoading = false;

          if (res.data.status == 200) {
            this.confirmSubmitDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.initialize();
            this.getAttachment();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      });
    },
    updateLink() {
      this.toUpdateLink = true;
    },
    showGDrive() {
      let url = this.ipcr_gDriveLink.link;
      window.open(url, "_blank");
    },

    saveAttachment() {
      if (this.$refs.AttachmentFormref.validate()) {
        this.isAttachmentBtnLoading = true;
        let data = {
          ipcrID: this.data.id,
          month: this.selectedMonth,
          year: this.data.year,
          action: this.uploadFileAction,
          prevFile: this.attachment ? this.attachment.filename : null,
          prev_id: this.attachment ? this.attachment.id : null,
        };
        let fd = new FormData();
        fd.append("data", JSON.stringify(data));
        fd.append("file", this.file_selected);

        // console.log(data);
        this.axiosCall("/ipcr-mpor/uploadAttachment", "POST", fd).then(
          (res) => {
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.isAttachmentBtnLoading = false;
              this.fileUploadDialog = false;
              this.initialize();
              this.getAttachment();
            } else {
              this.isAttachmentBtnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      }
    },

    viewFile() {
      let url =
        process.env.VUE_APP_SERVER +
        "/ipcr-target/previewFile/" +
        this.attachment.filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
      // window.open(url);
    },
    viewMPOR() {
      let url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/generateIPCRForm/MPOR/" +
        this.ipcrID +
        "?month=" +
        this.selectedMonth;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      // this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
